import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/yaPay.svg';

export const IconYaPay = createIconComponent(Icon);
